export default "__VITE_ASSET__c970d1b5__"